import {
  AggregatorKeysProps,
  AggregatorsProps,
  DimensionPrefixesProps,
  MeasurePrefixes,
} from './ChartAxesInterfaces';

const dimensionPrefixes: DimensionPrefixesProps = {
  integer: [],
  decimal: [],
  text: [],
  boolean:[],
  date: {
    timeGrain: [
      { name: 'Year', id: 'year' },
      { name: 'Quarter', id: 'quarter' },
      { name: 'Month', id: 'month' },
      { name: 'Year Quarter', id: 'yearquarter' },
      { name: 'Year Month', id: 'yearmonth' },
      { name: 'Date', id: 'date' },
      { name: 'Day of Month', id: 'dayofmonth' },
      { name: 'Day of Week', id: 'dayofweek' },
    ],
  },
  timestamp: {
    timeGrain: [
      { name: 'Year', id: 'year' },
      { name: 'Quarter', id: 'quarter' },
      { name: 'Month', id: 'month' },
      { name: 'Year Quarter', id: 'yearquarter' },
      { name: 'Year Month', id: 'yearmonth' },
      { name: 'Date', id: 'date' },
      { name: 'Day of Month', id: 'dayofmonth' },
      { name: 'Day of Week', id: 'dayofweek' },
      { name: 'Hours', id: 'hours' },
    ],
  },
};

const measurePrefixes: MeasurePrefixes = {
  integer: [
    { name: 'Sum', id: 'sum' },
    { name: 'Avg', id: 'avg' },
    { name: 'Min', id: 'min' },
    { name: 'Max', id: 'max' },
    { name: 'Count', id: 'count' },
    { name: 'Count Non Null', id: 'countnn' },
    { name: 'Count Null', id: 'countn' },
    { name: 'Count Unique', id: 'countu' },
  ],
  decimal: [
    { name: 'Sum', id: 'sum' },
    { name: 'Avg', id: 'avg' },
    { name: 'Min', id: 'min' },
    { name: 'Max', id: 'max' },
    { name: 'Count', id: 'count' },
    { name: 'Count Non Null', id: 'countnn' },
    { name: 'Count Null', id: 'countn' },
    { name: 'Count Unique', id: 'countu' },
  ],
  text: [
    { name: 'Count', id: 'count' },
    { name: 'Count Non Null', id: 'countnn' },
    { name: 'Count Null', id: 'countn' },
    { name: 'Count Unique', id: 'countu' },
  ],
  date: {
    aggr: [
      { name: 'Min', id: 'min' },
      { name: 'Max', id: 'max' },
      { name: 'Count', id: 'count' },
      { name: 'Count Non Null', id: 'countnn' },
      { name: 'Count Null', id: 'countn' },
      { name: 'Count Unique', id: 'countu' },
    ],
    timeGrain: [
      { name: 'Year', id: 'year' },
      { name: 'Quarter', id: 'quarter' },
      { name: 'Month', id: 'month' },
      { name: 'Date', id: 'date' },
      { name: 'Day of Month', id: 'dayofmonth' },
      { name: 'Day of Week', id: 'dayofweek' },
    ],
  },
  timestamp: {
    aggr: [
      { name: 'Min', id: 'min' },
      { name: 'Max', id: 'max' },
      { name: 'Count', id: 'count' },
      { name: 'Count Non Null', id: 'countnn' },
      { name: 'Count Null', id: 'countn' },
      { name: 'Count Unique', id: 'countu' },
    ],
    timeGrain: [
      { name: 'Year', id: 'year' },
      { name: 'Quarter', id: 'quarter' },
      { name: 'Month', id: 'month' },
      { name: 'Date', id: 'date' },
      { name: 'Day of Month', id: 'dayofmonth' },
      { name: 'Day of Week', id: 'dayofweek' },
      { name: 'Hours', id: 'hours' },
    ],
  },
  boolean: [
    { name: 'Count', id: 'count' },
    { name: 'Count Non Null', id: 'countnn' },
    { name: 'Count Null', id: 'countn' },
    { name: 'Count Unique', id: 'countu' },
  ],
};

const Aggregators: AggregatorsProps | any = {
  Dimension: dimensionPrefixes,
  Row: dimensionPrefixes,
  SplitBy: dimensionPrefixes,
  Column: dimensionPrefixes,
  Distribution: dimensionPrefixes,
  Measure: measurePrefixes,
  X: measurePrefixes,
  Y: measurePrefixes,
  Filter: measurePrefixes,
};

export const AggregatorKeys: AggregatorKeysProps = {
  sum: 'Sum',
  avg: 'Avg',
  min: 'Min',
  max: 'Max',
  count: 'Count',
  countnn: 'Count NN',
  countn: 'Count Null',
  countu: 'Count Unique',

  year: 'Year',
  yearquarter: 'Year Qtr',
  yearmonth: 'Year Mth',
  month: 'Month',
  quarter: 'Quarter',
  dayofmonth: 'Day Mn',
  dayofweek: 'Day Wk',
  date: 'Date',
  hours: 'Hours',
};

export default Aggregators;
